import {gql} from 'apollo-angular';
import {baseResponseGraphqlField} from '../../../../base.graphql';

export const createCitizenUsersField = `
id
citizenUniqueId
citizenUserProfile {
  id
  profileUniqueId
  userFirstName
  userLastName
  userEmail
  profilePhone
  profileTitle
  profilePhoto
  profileIsActive
  profileType
}
citizenNidaNumber
`;



export const CREATE_CITIZEN_USERS = gql`
mutation CreateCitizenUsers($input: CitizenProfileInputObject!) {
    createCitizenUsers(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${createCitizenUsersField}
    }
  }
}
`;
